'use es6';

import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    background-image: ", ";\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled, { useTheme } from 'styled-components';
import { isHalloween } from '../operators/isHalloween';
import { Pumpkin } from './Pumpkin';
import { SpiderWebLeft } from './SpiderWebs';
import { TabletAndBelow } from '../themes/mixins';
var ThemedPage = styled.div.withConfig({
  displayName: "ThemedHomePage__ThemedPage",
  componentId: "ra8v0h-0"
})(["background:", ";background-color:", ";", ""], function (_ref) {
  var theme = _ref.theme;
  return theme.homePage.background;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.homePage.backgroundColor;
}, TabletAndBelow(_templateObject(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.name === 'defaultTheme' ? 'none' : theme.homePage.backgroundImage;
}));
export var ThemedHomePage = function ThemedHomePage(_ref4) {
  var children = _ref4.children;
  var theme = useTheme();
  return /*#__PURE__*/_jsxs(ThemedPage, {
    children: [isHalloween(theme) && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Pumpkin, {}), /*#__PURE__*/_jsx(SpiderWebLeft, {})]
    }), children]
  });
};